/******/ (() => { // webpackBootstrap
/*!*********************************************!*\
  !*** ./zrc/scripts/sections/feature-row.js ***!
  \*********************************************/
class FeatureRow extends window.HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.init();
  }
  init() {
    $(document).on('closed', '.remodal', () => {
      $('.video-iframe').each(function () {
        this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      });
    });
    var videoIframe = document.querySelectorAll(".homepage-feature-iframe");
    videoIframe.forEach(element => {
      element.addEventListener("load", () => {
        element.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        element.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
      });
    });
  }
}
if (window.customElements.get('feature-row') == null) {
  window.customElements.define('feature-row', FeatureRow);
}
/******/ })()
;